import { IBillingRepository } from "../../adapters/driven/repositories/billingRepository";

export const BillingServiceImplFactory = ({
  billingRepository,
}: {
  billingRepository: IBillingRepository;
}) => {
  /**
   * Payers
   */
  const getPayers: IGetPayersService = async (payload) => {
    try {
      const response = await billingRepository.GetPayers(payload);
      return {
        success: response.success || !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updatePayer: IUpdateBillingPayer = async (payload) => {
    try {
      const response = await billingRepository.UpdatePayer(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createPayer: ICreateBillingPayer = async (payload) => {
    try {
      const response = await billingRepository.CreatePayer(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deletePayer: IDeleteBillingPayer = async (id) => {
    try {
      const response = await billingRepository.DeletePayer(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  /***********************************************************
   * Providers
   ***********************************************************/

  const getProviders: IGetProvidersService = async (payload) => {
    try {
      const response = await billingRepository.GetProviders(payload);
      return {
        success: !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateProvider: IUpdateBillingProvider = async (payload) => {
    try {
      const response = await billingRepository.UpdateProvider(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createProvider: ICreateBillingProvider = async (payload) => {
    try {
      const response = await billingRepository.CreateProvider(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deleteProvider: IDeleteBillingProvider = async (id) => {
    try {
      const response = await billingRepository.DeleteProvider(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  /***********************************************************
   * Entity
   ***********************************************************/
  const getEntities: IGetEntityService = async (payload) => {
    try {
      const response = await billingRepository.GetEntities(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateEntity: IUpdateBillingEntity = async (payload) => {
    try {
      const response = await billingRepository.UpdateEntity(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createEntity: ICreateBillingEntity = async (payload) => {
    try {
      const response = await billingRepository.CreateEntity(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deleteEntity: IDeleteBillingEntity = async (id) => {
    try {
      const response = await billingRepository.DeleteEntity(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  /***********************************************************
   * Rosters
   ***********************************************************/
  const getRosters: IGetRosterService = async (payload) => {
    try {
      const response = await billingRepository.GetRosters(payload);
      return {
        success: !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };
  const updateRoster: IUpdateBillingRoster = async (payload) => {
    try {
      const response = await billingRepository.UpdateRoster(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createRoster: ICreateBillingRoster = async (payload) => {
    try {
      const response = await billingRepository.CreateRoster(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deleteRoster: IDeleteBillingRoster = async (id) => {
    try {
      const response = await billingRepository.DeleteRoster(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  /***********************************************************
   * Patients
   ***********************************************************/
  const getPatients: IGetPatientsService = async (payload) => {
    try {
      const response = await billingRepository.GetPatients(payload);
      return {
        success: !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updatePatient: IUpdateBillingPatient = async (payload) => {
    try {
      const response = await billingRepository.UpdatePatient(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createPatient: ICreateBillingPatient = async (payload) => {
    try {
      const response = await billingRepository.CreatePatient(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deletePatient: IDeleteBillingPatient = async (id) => {
    try {
      const response = await billingRepository.DeletePatient(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  // Charges
  const getCharges: IGetBillingCharges = async (payload) => {
    try {
      const response = await billingRepository.GetCharges(payload);
      return {
        success: !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateCharges: IUpdateBillingCharges = async (payload) => {
    try {
      const response = await billingRepository.UpdateCharges(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createCharges: ICreateBillingCharges = async (payload) => {
    try {
      const response = await billingRepository.CreateCharges(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deleteCharges: IDeleteBillingCharges = async (id) => {
    try {
      const response = await billingRepository.DeleteCharges(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getChargesStatusSummary = async (payload: any) => {
    try {
      const response = await billingRepository.GetChargesStatusSummary(payload);
      return {
        success: response.success || !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const checkPatientEligibility: ICheckPatientEligibility = async (payload) => {
    try {
      const data = await billingRepository.GetEligibility(payload);
      const isErrorResponse =
        data != null && typeof data === "object" && "detail" in data;
      return { success: !isErrorResponse, data };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getPayers,
    updatePayer,
    createPayer,
    deletePayer,

    getProviders,
    updateProvider,
    createProvider,
    deleteProvider,

    getEntities,
    updateEntity,
    createEntity,
    deleteEntity,

    getRosters,
    updateRoster,
    createRoster,
    deleteRoster,

    getPatients,
    updatePatient,
    createPatient,
    deletePatient,

    getCharges,
    updateCharges,
    createCharges,
    deleteCharges,
    getChargesStatusSummary,
    checkPatientEligibility,
  };
};
